import { c as catalogGraphRouteRef, a as catalogEntityRouteRef } from './esm/routes-c6756725.esm.js';
export { A as ALL_RELATION_PAIRS, D as Direction, E as EntityRelationsGraph, c as catalogGraphRouteRef } from './esm/routes-c6756725.esm.js';
import { createPlugin, createComponentExtension, createRoutableExtension } from '@backstage/core-plugin-api';
import '@backstage/catalog-model';
import '@backstage/core-components';
import '@material-ui/core';
import 'classnames';
import 'react';
import '@material-ui/core/styles/makeStyles';
import '@backstage/plugin-catalog-react';
import '@material-ui/core/styles';
import '@material-ui/core/SvgIcon';
import 'react-use/lib/useDebounce';
import 'react-use/lib/useAsyncFn';

const catalogGraphPlugin = createPlugin({
  id: "catalog-graph",
  routes: {
    catalogGraph: catalogGraphRouteRef
  },
  externalRoutes: {
    catalogEntity: catalogEntityRouteRef
  }
});

const EntityCatalogGraphCard = catalogGraphPlugin.provide(
  createComponentExtension({
    name: "EntityCatalogGraphCard",
    component: {
      lazy: () => import('./esm/index-4d97d76b.esm.js').then((m) => m.CatalogGraphCard)
    }
  })
);
const CatalogGraphPage = catalogGraphPlugin.provide(
  createRoutableExtension({
    name: "CatalogGraphPage",
    component: () => import('./esm/index-201fbff6.esm.js').then((m) => m.CatalogGraphPage),
    mountPoint: catalogGraphRouteRef
  })
);

export { CatalogGraphPage, EntityCatalogGraphCard, catalogGraphPlugin };
//# sourceMappingURL=index.esm.js.map
